import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Traite le retour Google : #session_id=... → échange côté backend → session app
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { applySession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const sessionId = new URLSearchParams(hash.replace(/^#/, '')).get('session_id');
    window.history.replaceState(null, '', window.location.pathname + window.location.search);

    (async () => {
      try {
        const { data } = await axios.post(`${API_URL}/api/auth/google/session`, { session_id: sessionId });
        if (data.new_user) {
          navigate('/inscription', { replace: true, state: { google: data } });
          return;
        }
        await applySession(data);
        toast.success(`Bienvenue ${data.name}`);
        navigate(data.role === 'admin' || data.role === 'employee' ? '/admin' : '/', { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        toast.error(typeof detail === 'string' ? detail : 'Connexion Google impossible, réessayez.');
        navigate('/connexion', { replace: true });
      }
    })();
  }, [navigate, applySession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-main" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[color:var(--color-primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted text-sm">Connexion en cours…</p>
      </div>
    </div>
  );
}
